import { Box, Button, Grid, Typography, useTheme } from '@material-ui/core';
import { DialogSaurus } from '../dialog-saurus/dialog-saurus';
import { useCallback, useRef, useState } from 'react';
import { useToastSaurus } from 'services/app';
import { DefaultFormRefs } from 'views/components/form/utils';
import { AvancarIcon, OkIcon, VoltarIcon } from 'views/components/icons';
import { TransferirContratoFormModel } from 'model/app/forms/transferir-contrato/transferir-contrato-model';
import { FormTransferirContrato } from 'views/components/form/master/transferir-contrato/form-transferir-contrato';
import { usePutTransferirContrato } from 'data/api/gestao/contratos/put-transferir-contrato';
import { TransferirContratoModel } from 'model/api/gestao/contrato/transferir-contrato-model';
import { useStyles } from './dialog-transferir-contrato-styles';
import { stringNumeros } from 'utils/string-numeros';

interface DialogTransferirContratoProps {
    openned: boolean;
    closeDialog: () => void;
    contratoId: string;
    preencherTela: () => void
}

export const DialogTransferirContrato = ({
    openned,
    closeDialog,
    contratoId,
    preencherTela
}: DialogTransferirContratoProps) => {
    const theme = useTheme();
    const { showToast } = useToastSaurus()
    const [isSuccessTransferencia, setIsSuccessTransferencia] = useState(false)
    const classes = useStyles()


    const formRef = useRef<DefaultFormRefs<TransferirContratoFormModel>>(null)
    const { putTransferirContrato, carregando } = usePutTransferirContrato()


    const handleSubmit = useCallback(async (model: TransferirContratoFormModel) => {
        try {
            const contratoTransferencia: TransferirContratoModel = {
                contratoId: contratoId,
                cpfCnpjNovoCliente: stringNumeros(model.cnpj)
            }
            const res = await putTransferirContrato(contratoTransferencia)

            if (res.erro) throw res.erro
            setIsSuccessTransferencia(true)
            showToast('success', 'Contrato Transferido.')

        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [contratoId, putTransferirContrato, showToast])

    return (
        <DialogSaurus
            colorTitulo={`${theme.palette.primary.main}`}
            centralizarTitulo={true}
            aberto={openned}
            titulo='Transferir Contrato'
            tamanho="xs"
        >
            <Grid
                container
                spacing={2}
                style={{ marginBottom: '5px' }}
            >
                {isSuccessTransferencia ? (
                    <>
                        <Grid item xs={12}>
                            <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                                <OkIcon tipo='GERAL' class={classes.icon} />
                                <Typography variant="body1" align="center">Contrato transferido com sucesso! Revise os terminais, módulos e empresas vinculadas.</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                disabled={carregando}
                                variant="contained"
                                fullWidth
                                color="primary"
                                onClick={() => {
                                    preencherTela()
                                    closeDialog();
                                }}
                            >
                                <AvancarIcon tipo='BUTTON_PRIMARY' />
                                Concluir
                            </Button>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid item xs={12}>
                            <FormTransferirContrato
                                loading={carregando}
                                onSubmit={handleSubmit}
                                ref={formRef}
                                showLoading={carregando}
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            {closeDialog && (
                                <Button
                                    disabled={carregando}
                                    variant="outlined"
                                    fullWidth
                                    color="primary"
                                    onClick={() => {
                                        closeDialog();
                                    }}
                                >
                                    <VoltarIcon tipo='BUTTON' />
                                    Voltar
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button
                                disabled={carregando}
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => formRef.current?.submitForm()}>
                                <OkIcon tipo='BUTTON_PRIMARY' />
                                Confirmar
                            </Button>
                        </Grid>
                    </>
                )}
            </Grid>
        </DialogSaurus>
    );
};
